"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _xcx = require("@/api/xcx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      loading: true,
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getApplyList();
  },
  methods: {
    getApplyList: function () {
      var _getApplyList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.loading = true;
                _context.next = 4;
                return (0, _xcx.getApplyListAPI)();
              case 4:
                res = _context.sent;
                if (res.data) {
                  this.tableData = res.data;
                }
                console.log('res: ', res);
                _context.next = 11;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
              case 11:
                _context.prev = 11;
                this.loading = false;
                return _context.finish(11);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 11, 14]]);
      }));
      function getApplyList() {
        return _getApplyList.apply(this, arguments);
      }
      return getApplyList;
    }()
  }
};
exports.default = _default;